module.exports = __webpack_public_path__ + "img/5.27ab79b7.svg";